import i18next from "i18next";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateInProgress = (quantity: IQuantity, actions: any, selectedOrder?: any) => {
  const t = i18next.getFixedT(null, "admin");
  const items = [{
    key: "delete",
    text: t("orders.commandBar.cancelOrder"),
    iconProps: { iconName: "delete" },
    name: "delete",
    onClick: actions.setOrderCanceled,
  },
  {
    key: "restore",
    text: t("orders.commandBar.restoreToAccepted"),
    iconProps: { iconName: "Back" },
    name: "restore",
    onClick: actions.setOrderAccepted,
  },
  {
    key: "sms",
    text: t("orders.commandBar.sendSmsToDriver"),
    iconProps: { iconName: "Message" },
    name: "sms",
    onClick: actions.sendSMS,
  },]

  const cuoSplitsButton = selectedOrder && selectedOrder.isFromCuo === "CUO" ? [{
    key: "cuoSplits",
    text: t("orders.commandBar.manageCuoSplits"),
    iconProps: { iconName: "BranchMerge" },
    name: "cuoSplits",
    onClick: actions.openCuoSplitsPanel,
  }] : [];

  switch (quantity) {
    case Quantity.NONE:
      return [];
    case Quantity.ONE:
      return [
        {
          key: "see",
          text: t("orders.commandBar.see"),
          iconProps: { iconName: "textDocument" },
          onClick: actions.openPanelToSee,
        },
        {
          key: "edit",
          text: t("orders.commandBar.complete"),
          iconProps: { iconName: "edit" },
          onClick: actions.openPanel,
        },
        ...cuoSplitsButton,
        ...items
      ];
    case Quantity.MANY:
      return [...items];
  }
};
